import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { toFakeAgentName } from '../../../utils/userAnonymization';
import { Theme } from '../../../themes/types';

interface UserNameProps {
    name?: string | null;
}

export const UserName: React.FC<UserNameProps> = ({ name = '' }) => {
    const theme = useTheme<Theme>();

    return (
        <Box sx={{ justifySelf: 'flex-end' }}>
            <Typography color={theme.palette.headerTabTextColor} variant="body2" fontWeight="bold">
                <span data-test="header-user-name">{toFakeAgentName(name || '')}</span>
            </Typography>
        </Box>
    );
};
